<template>
  <div class="editBG mt-5 pt-3">
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      auto-height
      right
      top
      :timeout="timeout"
      vertical
    >
      {{ snackbarText }}
    </v-snackbar>

    <!-- <v-toolbar fixed tabs color="white elevation-1" style="top:55px; position:fixed;">
      <v-btn icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-btn>
      <v-toolbar-title>{{contactFormData.name}} </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon><v-icon>more_vert</v-icon></v-btn>
      <small>{{contact.name}}</small>
      
      <v-tabs slot="extension" color="transparent" slider-color="purple"  align-with-title v-model="currentTabContact">
        <v-tab v-for="tab in ['basic','image']" :ripple="false"
          :key="tab" 
          :href="'#tab-' + tab" 
          @click="saveCurrentTab('tab-' + tab)"
        >
          {{ tab }}
        </v-tab> 
      </v-tabs>
    </v-toolbar> -->

    <v-layout mx-0 pl-4 ml-0 mt-0 pb-0 class="editBG">
      <v-flex class="xs12 pl-3">
        <v-flex class="pb-0 mb-0 xs8 ">
          <h5 class="font-weight-light headline pt-2 my-0">
            New Contact
            <span class="font-weight-regular">{{ contact.name }}</span>
            <span class="font-weight-light" v-if="contact.category"
              >({{ contact.category }})</span
            >
          </h5>
        </v-flex>
        <!-- <v-flex class="xs12 ">
          <h4 class="headline py-0 my-0 ">{{ contact.company }}</h4>
        </v-flex> -->
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn
        icon
        small
        class="mr-5"
        color="#999"
        @click="
          options = false
          $router.go(-1)
        "
        ><v-icon small color="white">close</v-icon>
      </v-btn>
    </v-layout>

    <v-form @submit.prevent ref="form" v-model="valid" lazy-validation>
      <v-card class="px-3 pt-0 mt-0 elevation-0 editBG">
        <v-container grid-list-md fluid class="pt-2 mt-0">
          <v-layout row wrap>
            <v-flex
              style="background-color:#292929; color: #eee;"
              class="px-3 py-1 my-2 elevation-0 xs12"
            >
              <h3 class="font-weight-bold subtitle xs12 flex">Basic</h3>
            </v-flex>
            <v-flex px-3 xs12>
              <v-text-field
                label="Name * "
                v-model="contact.name"
              ></v-text-field>
            </v-flex>
            <v-flex px-3 xs6>
              <v-text-field
                :disabled="contact.category == 'artwork_acquisition_source'"
                label="First Name"
                v-model="contact.first_name"
              ></v-text-field>
            </v-flex>
            <v-flex px-3 xs6>
              <v-text-field
                :disabled="contact.category == 'artwork_acquisition_source'"
                label="Last Name"
                v-model="contact.last_name"
              ></v-text-field>
            </v-flex>
            <v-flex px-3 xs6>
              <v-text-field
                label="Company"
                :disabled="contact.category == 'artwork_acquisition_source'"
                v-model="contact.company"
              ></v-text-field>
            </v-flex>

            <v-select
              class="px-3"
              :items="[
                'artwork_acquisition_source',
                'registrar',
                'exhibition_institution'
              ]"
              v-model="contact.category"
              label="Category * "
            ></v-select>

            <v-flex xs12>
              <v-flex
                mt-3
                ml-2
                class="left"
                v-if="contact.category == null || contact.name == null"
                >* Obligatory fields</v-flex
              >
              <v-spacer></v-spacer>
              <v-btn
                class="right"
                :dark="
                  contact.category != null &&
                    contact.name != null &&
                    contact.name != ''
                "
                :disabled="
                  contact.category == null ||
                    contact.name == null || contact.name == '' ||
                    savingAnother
                "
                :loading="saving"
                @click="submit(false)"
              >
                save
              </v-btn>
              <v-btn
                class="right"
                color="green"
                :dark="canSave"
                :disabled="!canSave || saving"
                :loading="savingAnother"
                @click="submit(true)"
              >
                save and add another
              </v-btn>
              <v-btn class="right" @click="$router.go(-1)">cancel</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import axios from '@/utils/apiClient'

export default {
  data() {
    return {
      contact: {},
      contactFormData: {},
      snackbar: false,
      snackbarFieldName: '',
      snackbarColor: '',
      snackbarText: '',
      timeout: 3000,
      result: '',
      valid: true,
      saving: false,
      savingAnother: false
    }
  },
  methods: {
    humanize(t) {
      return t.replace(/_/g, ' ').replace(/(?: |\b)(\w)/g, function(t) {
        return t.toUpperCase()
      })
    },
    getContact() {
      // console.log('test output getcontact')
      let url = `${this.$globals.apiserver}/contacts/${this.contact.id}.json`
      // let url = `http://www.tba21.org/contact.json?id={{contact.id}}`
      // console.log(url)
      axios
        .get(url)
        .then(() => {
          // this.loading = false;
          this.contact = response.data
        })
        .catch(() => {
          // console.log(error);
        })
    },
    clear() {
      this.$refs.form.reset()
    },
    submit(addAnother) {
      // const c = this.contactFormData
      // const requestConfig = {
      //     url     : `${this.$globals.apiserver}/contacts/api_update/${this.$route.params.id}`,
      //     method  : "POST",
      //     data : qs.stringify(c)
      // }
      // const response = axios.request(requestConfig)

      let url = `${this.$globals.apiserver}/contacts.json`
      this.saving = !addAnother
      this.savingAnother = addAnother
      // console.log(url)
      axios
        .post(url, this.contact)
        // {
        //   name: this.contact.name,
        //   category: this.contact.category,
        //   company: this.contact.company,
        //   first_name: this.contact.first_name,
        //   last_name: this.contact.last_name,
        //   id: this.contact.id
        // }
        .then(response => {
          this.$store.dispatch('loadContacts')
          // console.log(response.data)
          // this.$router.push({
          //   name: "EditContact",
          //   params: { id: response.data.id, contact: response.data }
          // // contact: response.data, id: response.data.id
          // });
          if (addAnother) {
            this.contact = {}
            this.$nextTick(() => this.$refs.form.resetValidation())
            this.snackbar = true
            this.snackbarColor = 'green'
            this.snackbarText = 'Contact was saved. You can add another contact.'
          } else {
            this.$router.push({ name: 'Contacts', query: { saved: 'contact' } })
          }
          // this.loading = false;
          // this.result = response.data
          // this.artwork = response.data
          // this.artwork = response.data
          // this.artist = response.data.artist
          // this.e1 = 3
          // console.log(this.artwork)
        })
        .catch(error => {
          this.snackbar = true
          this.snackbarColor = 'red'
          this.snackbarText = 'Error occurred while saving contact.'
        })
        .then(() => {
          this.saving = false
          this.savingAnother = false
        })
    }
  },
  computed: {
    canSave() {
      return !!(this.contact.category && this.contact.name)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/contacts/AddContact.vue